import { AssignmentsState } from './state';
import { AssignmentsActionsUnion, AssignmentsActionTypes } from './actions';

export const initialAssignmentsState: AssignmentsState = {
  error: undefined,
  loaded: false,
  loading: false,
  userIds: undefined,
  dealId: undefined,
  saving: false,
  savingError: undefined
};

export function assignmentsReducer(
  state = initialAssignmentsState,
  action: AssignmentsActionsUnion
) {
  switch (action.type) {
    case AssignmentsActionTypes.Load:
      return {
        ...state,
        error: undefined,
        savingError: undefined,
        saving: false,
        loaded: false,
        loading: true,
        userIds: undefined,
        dealId: action.payload
      };
    case AssignmentsActionTypes.LoadSuccess:
      return {
        ...state,
        error: undefined,
        loaded: true,
        loading: false,
        userIds: action.payload
      };
    case AssignmentsActionTypes.LoadFail:
      return {
        ...state,
        error: action.payload,
        loaded: false,
        loading: false,
        userIds: undefined
      };
    case AssignmentsActionTypes.AssignUsers:
      return {
        ...state,
        saving: true,
        savingError: undefined
      };
    case AssignmentsActionTypes.AssignUsersSuccess:
      return {
        ...state,
        userIds:
          action.payload.dealId === state.dealId
            ? action.payload.userIds
            : state.userIds,
        saving: false
      };
    case AssignmentsActionTypes.AssignUsersFail:
      return {
        ...state,
        saving: false,
        savingError: action.payload
      };
    default:
      return state;
  }
}
